import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="email-detail"
export default class extends Controller {
  static targets = ['toggle', 'details'];
  static classes = ['toggle'];

  toggle(event) {
    this.detailsTarget.classList.toggle(this.toggleClass);

    if (this.detailsTarget.classList.contains(this.toggleClass)) {
      this.toggleTarget.innerHTML = 'Show Details';
    } else {
      this.toggleTarget.innerHTML = 'Hide Details';
    }
  }
}
